import React, {useCallback} from 'react';
import {useStores} from "../../stores";
import {observer} from "mobx-react-lite";
import type {Option, SelectionResult} from "../../components/visualization/api-dropdown-filter/ApiDropdownTypes";
import type {PageResponse} from "../../services/ApiTypes";
import {
    ApiDropdownFilterComponent,
    DEFAULT
} from "../../components/visualization/api-dropdown-filter/ApiDropdownFilterComponent";

type Selection = SelectionResult<number>;
export const SearchBusinessUnitAutocomplete: React.FC = observer(() => {
    const {p, bagStore, materializedApi} = useStores();

    const selection: Selection = bagStore.advanced.filters.business_unit_ids || DEFAULT;

    /**
     * Note: We filter the parent suppliers by the selected suppliers as well
     *  We could consider not filtering the supplier and parent supplier fields together
     */
    const filter = bagStore.advanced.filterQueryParamsBusinessUnits;

    const getOptions = useCallback(
        search => (bagStore.advanced.databagId && bagStore.advanced.ready) ? materializedApi.searchInsightBusinessUnits(bagStore.advanced.databagId, filter, search)
            .then<PageResponse<Option>>(resp => ({
                count: resp.data.length,
                next: '',
                previous: '',
                results: resp.data.map(obj => ({
                    id: obj.id,
                    label: obj.bu_name,
                    subLabel: obj.bu_id,
                    subTotalSpend: Number(obj.total_spend),
                    obj,
                }))
            })) : null,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [bagStore.advanced.databagId, bagStore.advanced.ready, filter]
    );

    if (!bagStore.advanced.ready) return <></>;
    return <ApiDropdownFilterComponent
        selection={selection}
        label={p.buDataName}
        enableLabelStatus
        getOptions={getOptions}
        showOptionSubLabel={p.p.showBuWithId}
        onSelectionChange={selection => bagStore.advanced.businessUnitFilterChanged(selection as Selection)}
        buttonProps={{fullWidth: true, sx: {height: '100%'}}}
    />
})
